import { snakeCase } from 'lodash'
import { MARITAL_STATUS_OPTIONS, OWNING_ENTITY_OPTIONS } from '../constants'

export const owningEntityOptions = elmId =>
  OWNING_ENTITY_OPTIONS.map(option => ({
    ...option,
    'data-elm-id': `${elmId}_who_is_taking_option_${snakeCase(option.value)}`,
  }))

export const maritalStatusOptions = elmId =>
  MARITAL_STATUS_OPTIONS.map(option => ({
    ...option,
    'data-elm-id': `${elmId}_marital_status_option_${snakeCase(option.value)}`,
  }))
